require("jquery-waypoints/waypoints");

$(document).ready(function () {
    const $section = $(".section-investment-capabilities");
    if ($section && $section.length) {
        //init function
        animTiles();

        // Make externally referenced SVGs work on older browsers
        try {
            svg4everybody();
        } catch (ReferenceError) {
            if (window.location.pathname.indexOf("investment-capabilities") != -1) {
                console.log("svg4everybody is not available. check package compatibility.");
            } else {
                console.log("svg4everybody is not involved yet.");
            }
        }
    }
});

//5 columns red cards function
//Global values
const easeNone = Linear.easeNone;
const easeInOut = Power2.easeInOut;
const easeOut = Power2.easeOut;

//Anim tiles
var played = false;

function animTiles() {
    $.fn.digits = function () {
        return this.each(function () {
            $(this).text(
                $(this)
                    .text()
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"),
            );
        });
    };

    //Waypoint triggers
    const offsetTileStartDown = "80%";
    const offsetTileStartUp = "0%";

    //Scroll down to animation
    $("ul.tile-stats li").waypoint(
        (direction) => {
            if (direction === "down" && played === false) {
                startAnimTiles();
                played = true;
            }
        },
        {
            offset: offsetTileStartDown,
        },
    );

    //Scroll up to animation
    $("ul.tile-stats li").waypoint(
        (direction) => {
            if (direction === "up" && played === false) {
                startAnimTiles();
                played = true;
            }
        },
        {
            offset: offsetTileStartUp,
        },
    );
}

function startAnimTiles() {
    $("ul.tile-stats li").each(function (i) {
        $(this)
            .delay(i++ * 500)
            .addClass("visible");
    });

    //Animating values
    var animDur = 3;
    var countVal1 = { countOne: 0 };
    var countVal2 = { countTwo: 0 };
    var countVal3 = { countThree: 0 };
    var countVal4 = { countFour: 0 };
    var countVal5 = { countFive: 0 };
    var $valueOne = $(".tile-one .word.count");
    var $valueTwo = $(".tile-two .word.count");
    var $valueThree = $(".tile-three .word.count");
    var $valueFour = $(".tile-four .word.count");
    var $valueFive = $(".tile-five .word.count");

    function animValueOne() {
        TweenMax.to(countVal1, animDur, {
            delay: 0.75,
            countOne: "+=500",
            roundProps: "countOne",
            onUpdate: updateOne,
            ease: easeInOut,
        });
    }

    function animValueTwo() {
        TweenMax.to(countVal2, animDur, {
            delay: 1,
            countTwo: "+=16000",
            roundProps: "countTwo",
            onUpdate: updateTwo,
            ease: easeInOut,
        });
    }

    function animValueThree() {
        TweenMax.to(countVal3, animDur, {
            delay: 1.25,
            countThree: "+=8",
            roundProps: "countThree",
            onUpdate: updateThree,
            ease: easeInOut,
        });
    }

    function animValueFour() {
        TweenMax.to($(".icon-pie-full"), 1.5, { delay: 1.5, onComplete: fadePie });
        TweenMax.to(countVal4, animDur, {
            delay: 1.5,
            countFour: "+=80",
            roundProps: "countFour",
            onUpdate: updateFour,
            ease: easeInOut,
        });
    }

    function animValueFive() {
        TweenMax.to($(".icon-folder-contain"), 1.5, { delay: 1.5, onComplete: animFolders });
        TweenMax.to(countVal5, animDur, {
            delay: 1.5,
            countFive: "+=90",
            roundProps: "countFive",
            onUpdate: updateFive,
            ease: easeInOut,
        });
    }

    function updateOne() {
        $valueOne.html(countVal1.countOne);
    }

    function updateTwo() {
        $valueTwo.html(countVal2.countTwo);
        $valueTwo.digits();
    }

    function updateThree() {
        $valueThree.html(countVal3.countThree);
    }

    function updateFour() {
        $valueFour.html(countVal4.countFour + "%");
    }

    function updateFive() {
        $valueFive.html(countVal5.countFive + "%");
    }

    function fadePie() {
        $(".icon-pie-full").fadeOut();
    }

    function animFolders() {
        var animMult = 7;
        var tl = new TimelineMax();
        tl.to($(".icon-folder-contain:nth-child(2)"), 1, { x: animMult, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(3)"), 1, { x: animMult * 2, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(4)"), 1, { x: animMult * 3, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(5)"), 1, { x: animMult * 4, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(6)"), 1, { x: animMult * 5, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(7)"), 1, { x: animMult * 6, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(8)"), 1, { x: animMult * 7, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(9)"), 1, { x: animMult * 8, ease: easeInOut }, 0);
        tl.to($(".icon-folder-contain:nth-child(10)"), 1, { x: animMult * 9 + 10, ease: easeInOut }, 0);
        tl.to(
            $(".fold"),
            0.75,
            { css: { transform: "skewX(-20deg) skewY(-29deg) scale(1,0.8)" }, ease: Elastic.easeOut.config(1, 0.3) },
            1,
        );
    }
    //Get it started
    animValueOne();
    animValueTwo();
    animValueThree();
    animValueFour();
    animValueFive();
}
